import React, { CSSProperties, FC, PropsWithChildren } from 'react'

import { styled as MuiStyled } from '@mui/material/styles'
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import clsx from 'clsx'

import { RangeDateDropdownArrow } from 'src/components/molecules'

import styles from './calendarPopoverContainer.module.scss'

const HtmlTooltip = MuiStyled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    width: '25.71rem',
    backgroundColor: 'unset',
    color: 'unset',
    fontSize: 'var(--s0)',
  },
}))

type Props = {
  isShowCalendar: boolean
  arrowStyle?: CSSProperties
  calendar: React.ReactNode
  forwardRef?: React.Ref<HTMLDivElement> | React.ForwardedRef<HTMLDivElement>
  id?: string
  className?: string
}

const BaseCalendarPopoverContainer: FC<PropsWithChildren<Props>> = ({
  isShowCalendar,
  arrowStyle,
  calendar,
  forwardRef,
  id,
  children,
  className,
}) => {
  return (
    <div className={className} ref={forwardRef}>
      {/* NOTE:
       親要素でoverflowを利用している場合、シンプルな position を使った組み合わせの場合カレンダーの要素が親要素の幅で見切れてしまう
       そのためmuiのTooltipを利用してルート要素に配置する事で見切れないようにする
       */}
      <HtmlTooltip
        id={id}
        sx={{
          width:
            'calc(25.71rem +  1.4rem)' /* 表示するカレンダーより少しだけ横幅がないと画面外に要素がはみ出してスクロールできるようになってしまう */,
        }}
        open={isShowCalendar}
        title={
          <div className={clsx(styles.calendarContainer, 'tw-bg-background-secondary')}>
            <div style={arrowStyle} className={clsx(styles.arrowContainer)}>
              <RangeDateDropdownArrow />
            </div>
            {calendar}
          </div>
        }
      >
        <div>{children}</div>
      </HtmlTooltip>
    </div>
  )
}

export const CalendarPopoverContainer = React.forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  (props, ref) => {
    return <BaseCalendarPopoverContainer {...props} forwardRef={ref} />
  }
)
